import React, { Component } from 'react';
import classNames from 'classnames';
import { AutoAffix } from 'react-overlays';

export class ResearchNav extends Component {
  render() {
    const showNav =
      this.props.sortedSections.length >= 2 ||
      this.props.hasVideos ||
      this.props.hasCourses;

    if (!showNav) {
      return null;
    }

    return (
      <div className="research-nav">
        <AutoAffix viewportOffsetTop={0}>
          <nav>
            <ul className="nav nav-pills nav-stacked">
              {this.props.hasCourses && (
                <li key="courses">
                  <a
                    href="#courses"
                    className={classNames({
                      active: this.props.currSection === 'courses',
                    })}
                  >
                    Courses
                  </a>
                </li>
              )}
              {this.props.hasVideos && (
                <li key="videos">
                  <a
                    href="#videos"
                    className={classNames({
                      active: this.props.currSection === 'videos',
                    })}
                  >
                    Videos
                  </a>
                </li>
              )}
              {this.props.sortedSections.map((section) => (
                <li key={section.id}>
                  <a
                    href={`#${section.url_safe_name}`}
                    className={classNames({
                      active: this.props.currSection === section.url_safe_name,
                    })}
                  >
                    {section.display_name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </AutoAffix>
      </div>
    );
  }
}

export default ResearchNav;
